module.exports = __webpack_public_path__ + "static/media/1_A1_20.a85a0f5a.png";